module.exports = __webpack_public_path__ + "img/banner-about.f41cb3ad.png";